module.exports = __webpack_public_path__ + "img/CtrlRoom_music_1.0a1a3192.png";